exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".g-signin-button{display:inline-block;padding:4px 8px;border-radius:3px;background-color:#3c82f7;color:#fff;box-shadow:0 3px 0 #0f69ff}", ""]);

// exports
